import { CreateSiteCommand } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { Site } from "src/sites/types";

export async function createSiteService(site: Site) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new CreateSiteCommand(site);
  const metricsPublisher = new MetricsPublisher("api.createSite");

  return await client
    .send(command)
    .then((response) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
